import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Ensure theme is applied before first paint, even on unauthenticated routes
function applyInitialTheme() {
  try {
    const html = document.documentElement;
    const stored = localStorage.getItem('theme') || 'dark';
    const resolve = (mode) => {
      if (mode === 'system') {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      }
      return mode;
    };
    const resolved = resolve(stored);
    html.setAttribute('data-theme', resolved);
    if (resolved === 'dark') {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }

    // If following system, update on system changes
    if (stored === 'system') {
      const mql = window.matchMedia('(prefers-color-scheme: dark)');
      const listener = () => {
        const next = resolve('system');
        html.setAttribute('data-theme', next);
        if (next === 'dark') html.classList.add('dark'); else html.classList.remove('dark');
      };
      if (mql.addEventListener) mql.addEventListener('change', listener);
      else mql.addListener(listener);
    }
  } catch (_) {
    // no-op
  }
}

async function bootstrap() {
  // axe runtime dev checks disabled for now due to unstable deps
  applyInitialTheme();

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();